import { render, staticRenderFns } from "./CartProduct.vue?vue&type=template&id=4c44142e"
import script from "./CartProduct.vue?vue&type=script&lang=ts"
export * from "./CartProduct.vue?vue&type=script&lang=ts"
import style0 from "./CartProduct.vue?vue&type=style&index=0&id=4c44142e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports